import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

const config = require('../branding/branding.json');
let logo;
if (!config.logoExternal) {
    logo = require(`../${config.logoUrl}`);
} else {
    logo = config.logoUrl;
}

import './Sidebar.css';
import brandingStyles from '../branding/brandingStyles';


// Since logo is only present there, defining layout style here
const logoStyle = {
    maxWidth: '220px',
    margin: '10px',
};

class AccountsSidebarComponent extends Component {
    render() {
        return (
            <div
              className="navbar-default sidebar"
              role="navigation"
              style={brandingStyles.backgrounds.menu}
            >
                <div className="sidebar-nav navbar-collapse">
                    <Link to="/accounts">
                      <img src={logo} style={logoStyle} alt="Scality logo">
                      </img>
                    </Link>
                    <ul className="nav" id="side-menu">
                        <li>
                            <NavLink
                              to="/accounts"
                              exact
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-user-circle">
                                </i> Accounts
                            </NavLink>
                            <NavLink
                              to="/accounts/system"
                              exact
                              activeClassName="active"
                              activeStyle={brandingStyles.navItemActive}
                            >
                                <i className="fa fa-pie-chart">
                                </i> System metrics
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default AccountsSidebarComponent;



/** WEBPACK FOOTER **
 ** ./src/components/AccountsSidebar.js
 **/